"use strict";
'use es6';
/*******************************************************************
calculate vertical margin based on percentage against width, because
measurements are relative to width, not height
*******************************************************************/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toScaledPercentage = void 0;

var toScaledPercentage = function toScaledPercentage(dimensions, side) {
  return dimensions[side] / dimensions.width * 100 + "%";
};

exports.toScaledPercentage = toScaledPercentage;